import { DOT } from "../utils/frfr-string-consts";
import tclocal from "./ter-consts-local-lib";
import { js_utils } from '../utils/frfr-js-utils.js';
import { _getParamSingleFromSifrarnikOp, _getParamSingleFromSifrarnikRadnicentri } from "./ter-params-utils";
import { terUtilsNumberRoundClassic, terUtilsNumberRoundUp } from "./ter-utils";
import { ter_recnik_kljuceva_smart_get } from "./ter-multitranslator-lib";


// sastavnica 21r3 element-lib

/*
  DA/NE preimanovati u YES/NO uvek na eksportu jer tako je izvorno tj na importu.

*/

//
const _special_enrich_by_extra_siframodula = (p, j) => {
  console.log('_special_enrich_by_extra_siframodula(p, j)', p, j);
  // "_extra_siframodula": null, // NOVO 2025-03-18
  /*
  if (js_utils.is_string_not_empty(p._ident_modula)) {
    j._ident_modula = p._ident_modula; // NJ 2025-03-02
  }
  */
  if (js_utils.is_string_not_empty(p._extra_siframodula)) {
    j._ident_modula = p._extra_siframodula; // NOVO 2025-03-18
  } else {
    // else no changes
  }
  return j;
};


const default_element = (p) => {
  /*
  _getParamsFromLib("terkk$profilosnovni") = {
    angazovanihradnika: 1,
    vremepripreme: 0,
    vremeoperacije: 1,
    vremeugradnje: 3,
    vremekumulativno
  };
  */
  let Par_jezik = null;
  let angazovanihradnika = null;
  let vremepripreme = null;
  let vremeoperacije = null;
  let vremeugradnje = null;
  let vremeopsklapanje = null;
  let vremekumulativno = null;
  let stepenslozenosti = null;
  if (js_utils.is_number_zero_or_greater(p.angazovanihradnika)) {
    angazovanihradnika = p.angazovanihradnika;
  }
  if (js_utils.is_number_zero_or_greater(p.vremepripreme)) {
    vremepripreme = p.vremepripreme;
  }
  if (js_utils.is_number_zero_or_greater(p.vremeoperacije)) {
    vremeoperacije = p.vremeoperacije;
  }
  if (js_utils.is_number_zero_or_greater(p.vremeugradnje)) {
    vremeugradnje = p.vremeugradnje;
  }
  if (js_utils.is_number_zero_or_greater(p.vremeopsklapanje)) {
    vremeopsklapanje = p.vremeopsklapanje;
  }
  if (js_utils.is_number_zero_or_greater(p.vremekumulativno)) {
    vremekumulativno = p.vremekumulativno;
  }
  if (js_utils.is_number(p.stepenslozenosti)) {
    stepenslozenosti = p.stepenslozenosti;
  }
  if (vremeopsklapanje > 0) {
    // samo za potrebe sastavnica, u vreme operacije pisemo Vreme_op_sklapanje
    vremeoperacije += vremeopsklapanje;
  }
  //
  let Ident_prefix = null;
  if (js_utils.is_string_not_empty(p.teridentprefix)) {
    Ident_prefix = p.teridentprefix;
  }
  //
  const _radni_centar = _getParamSingleFromSifrarnikRadnicentri(p.rc);
  let _CNC_tip = null;
  if (p.rc === "RCPRBS4" || p.rc === "RCLINS4P4") {
    _CNC_tip = "S4";
  }
  if (p.rc === "RCPRBAM") {
    _CNC_tip = "AMADA";
  }
  if (js_utils.is_string_not_empty(p.multitranslator_lang)) {
    Par_jezik = p.multitranslator_lang;
  }
  return {
    //
    Nivo: p.bomlevel,
    Nivo_importovani: p.bomlevel_imported,
    Kolicina: p.kolicina,
    JM: p.jm,
    Kat: p.terkategorija,
    Grupa: p.tergrupa,
    Ident_prefix, // NOVO 2023-11-08
    virtelclass: p.virtelclass, // NOVO
    Calculated_ident: p.calculated_ident,
    Custom_ident: p.identcustom,
    Genus_ident: p.genus_ident,
    //
    // POLJA OD DOPUNE SASTAVNICE
    acIdent: null,
    acIdentChild: null,
    infoID: null,
    //
    // POLJA OD OPERACIJA...
    Operacija: _getParamSingleFromSifrarnikOp(p.operacija),
    Radni_centar: _getParamSingleFromSifrarnikRadnicentri(p.rc),
    Broj_izvrsioca: angazovanihradnika,
    Vreme_pripreme: vremepripreme,
    Vreme_operacije: vremeoperacije,
    Vreme_ugradnje: vremeugradnje,
    Vreme_op_sklapanje: vremeopsklapanje,
    Stepen_slozenosti: stepenslozenosti,
    Vreme_kumulativno: vremekumulativno,
    Kolicina_za_nalog: p.kolicina_za_nalog,
    //
    Par_jezik,
    // NOVA POLJA za CNC programe
    Materijal: p.termaterijal, // NOVO,
    _CNC_tip, // NOVO 2023-07-11
    //
    // NOVO 2024-04-23
    "Masa_po_jm": p.masa_po_jm,
    // "Masa": p.masa,
    "Masa_kumulativno": terUtilsNumberRoundUp(p.masa_kumulativno, 3), // za prikaz u sastavnicu masu (u kg) zaokružujemo na 3 decimale
    //
    // NOVO 2024-11-14
    "Cena_po_jm": p.cena_po_jm,
    // "Cena": p.cena,
    "Cena_kumulativno": terUtilsNumberRoundUp(p.cena_kumulativno, 2), // za prikaz u sastavnicu cenu (u valuti?) zaokružujemo na 2 decimale
  };
  // Pripremno_vreme preimenovao sam u Vreme_pripreme
};



const element = {};


element.WARNING_SEMA_NOT_FOUND = (p) => {
  // objekat za element sastavnice koji ima neispravnu virtel semu
  let j = {
    ...default_element(p)
  };
  j.Kat = 'X';
  //
  j._debug = 'SEMA_NOT_FOUND';
  console.log('element.WARNING_SEMA_NOT_FOUND', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.klimakomora = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  console.log('default_element', j);
  // j.Nivo = p.bomlevel;
  // j.Kat = 'PP'; // uzimamo iz fixed_fields
  // j.Grupa = 'AHU'; // uzimamo iz fixed_fields
  j.Ident = p.sifrakomore;
  j.Naziv = p.nazivkomore;
  j.Tip = p.tipkomore;
  // Kolicina = p.kolicina; 
  // jm = tclocal.JM_KOM;
  /*
  Par1	Da	Da	Naziv sistema name: nazivkomore (text)
  Par2	Da	Da	Sistem konstrukcije name: vrstaprofila
  Par3	Da	Da	Insulation name: tipispuneklimakomore
  Par4	Da	Da	Velicina komore 1 name: _sirinakomoreoznaka . name: _visinakomore
  Par5	Da	Da	Veličina komore (2) name: _sirinakomore2oznaka . name: _visinakomore2
  Par6	Ne	Da	Exhaust air volume flow.
  Par7	Ne	Da	Supply air volume flow.
  Par8	Ne	Da	Exhaust section.
  Par9	Ne	Da	Supply section.
  Par10	Ne	Da	Energy Class.
  Par11	Ne	Da	Ecodesign status.
  Par12	Ne	Da	Unit selling price
  Par13	Ne	Da	Unit net price
  Par14	Ne	Da	Overall width
  Par15	Ne	Da	Overall height
  Par16	Ne	Da	Weight
  Par17	Ne	Da	Inspection side
  Par18	Da	Da	Internal side material. name: unutrasnjaoplata
  */
  j.Par1 = p.nazivsistema;
  j.Par2 = p.vrstaprofila;
  j.Par3 = p.tipispuneklimakomore;
  j.Par4 = p.sirinakomoreoznaka + DOT + p.visinakomoreoznaka;
  if (!(p.sirinakomore2oznaka === null || p.visinakomore2oznaka === null)) {
    j.Par5 = p.sirinakomore2oznaka + DOT + p.visinakomore2oznaka;
  }
  //
  j.Par6 = p.Par6;
  j.Par7 = p.Par7;
  j.Par8 = p.Par8;
  j.Par9 = p.Par9;
  j.Par10 = p.Par10;
  j.Par11 = p.Par11;
  // j.Par12 = p.Par12;
  // j.Par13 = p.Par13;
  j.Par14 = p.Par14;
  j.Par15 = p.Par15;
  j.Par16 = p.Par16;
  j.Par17 = p.Par17;
  j.Par18 = p.Par18;
  j.Par19 = p.unutrasnjaoplata;
  j.Par28 = p.Par28;
  j.Par29 = p.Par29;
  //
  if (js_utils.is_string_not_empty(p.multitranslator_lang)) {
    j.Par_jezik = "terkk$klimakomora/klimakomora"; // BUDZENJE TODO uraditi na nivou samih virtela...
  }
  //
  j._debug = 'kk';
  console.log('element klimakomora', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.modul = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };

  // j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Ident = p.siframodula; // AHUM1
  // j.Ident = p.calculated_ident; // AHUM1
  j.Custom_ident = p.calculated_ident; // AHUM1
  j.Naziv = p.nazivmodula; //  *** ali sada treba da ostane ono sto je importovano iz kolone Naziv
  j.Kolicina = 1; // uvek 1 ???
  /*
  Par1	Da	Da	Modul width. Širina komore (spoljašnja)
  Par2	Da	Da	Modul height. Visina komore (spoljašnja)
  Par3	Da	Da	Modul Length. name: duzinamodula (number)
  */
  j.Par1 = p.msirinaspoljasnja;
  j.Par2 = p.mvisinaspoljasnja;
  j.Par3 = p.duzinamodula;
  //
  j.Par4 = p.Par4;
  j.Par5 = p.Par5;
  //
  if (js_utils.is_string_not_empty(p.multitranslator_lang)) {
    j.Par_jezik = "terkk$modul/modul"; // BUDZENJE TODO uraditi na nivou samih virtela...
  }
  //
  j._debug = 'modul';
  return _special_enrich_by_extra_siframodula(p, j);
};


const _special_Par_za_panel_i_lim_helper = (p) => {
  // Priprema parametre Par1 - Par30 za panel i lim
  let j = {};
  j.Par1 = p.sirina;
  j.Par2 = p.visina;
  // j.Par3 = p.revizioniotvor; // DA/NE ili Yes/No

  /*
  TODO:
  - u poluproizvodu group:'kamenavuna', u nazivu umesto reci KAMENA VUNA da pise ISPUNA KAMENA VUNA ili ISPUNA POLIURETAN
  - grupa da se ne zove kamena vuna nego ISPUNA (sve velika slova za nazive grupa)

  - panel na priemr 1.1.9
  njegovi poluproizvodi
  1.1.9.3 spoljasnji lim - ima tip koji treba da ode u Par14 u sastavnici.
  i
  1.1.9.4 unutrasnji lim - ima tip koji treba da ode u Par16 u sastavnici.

  - TODO dodati dva kvadratna otvora i nova polja u definicije
  */

  //
  // za slucaj kada ima samo jedan otvor
  j.Par3 = p.a; // Par3 A ako je kvadratni, D1 ako je okrugli.
  if (p.tippanela === 'okrugliotvor1' || p.tippanela === 'okrugliotvor2') {
    j.Par3 = p.d1;
  }
  j.Par4 = p.b; // samo ako je kvadratni otvor
  j.Par5 = p.x1; //
  j.Par6 = p.y1; //
  //
  // za drugi otvor, kada ima
  j.Par7 = p.a2; // Par7 A2 ako je kvadrtani, D2 ako je okrugli.
  if (p.tippanela === 'okrugliotvor1' || p.tippanela === 'okrugliotvor2') {
    j.Par7 = p.d2;
  }
  j.Par8 = p.b2; // ??? verovatno ce da bude b2 (visina otvora) on jos nije implementiran, to je za slucaj ako imamo dva kvadratna otvora
  j.Par9 = p.x2; //
  j.Par10 = p.y2; //
  //
  // TODO dodati dva kvadratna otvora tip panela... +++++++
  //
  j.Par11 = p.revizioniotvor; // DA/NE ili Yes/No
  j.Par12 = p.kljuc; //
  j.Par13 = p.sigurnosnabrava; //
  j.Par14 = p.panel_lim_spoljasnji_tip; // TDDO ???
  j.Par15 = 'IFF0030A0045'; // TICKET Za Par 15 ako je poliuretan sifra je IFF0030A0045
  if (p.tipispuneklimakomore === 'kamenavuna') {
    j.Par15 = 'IAGIA45'; // ako je kamena vuna sifra je IAGIA45
  }
  j.Par16 = p.panel_lim_unutrasnji_tip; // TDDO ???
  if (p.tippanela === "panelvrata") {
  }
  if (p.revizioniotvor === "DA" && p.tippanela === "standardni" && p.virtelclass === "terkk$panel_tip_vrata$op_pre_vrata") { // NOVO 2024-05-31
    // NJ 2024-05-31: kada je u pitanju standardni panel koji ima reviozioni otvor
    // Za standardni panel sa revizijom potrebno je na drugom nivou (prva operacija terkk$panel_tip_vrata$op_pre_vrata koji takodje ima podesen Ident_prefix PAV u Virtel Params) dodati Par17, kako bi se HASH child-a razlikovao od roditelja.
    // Par17 može da ima vrednosti DA, NE i proračunava se ukoliko TIP (kolona F) ima vrednost"standardni" i ukoliko Par11 (kolona Z) ima vrednost "DA"
    j.Par17 = "DA";
  }
  return _special_enrich_by_extra_siframodula(p, j);
};


element.panel = (p) => {
  // objekat za element sastavnice _____
  // console.log('**** TEST panel p za export sastavnicu');
  // console.log(p);
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  // j.Custom_ident = 'NE JOS';
  j.Custom_ident = null;
  j.Naziv = p.naziv;
  j.Tip = p.tippanela;
  j.Kolicina = p.kolicina;
  j = {
    ...default_element(p),
    ...j,
    ..._special_Par_za_panel_i_lim_helper(p)
  };
  //
  return _special_enrich_by_extra_siframodula(p, j);
};


element.panel$derivat1 = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice _____
  // console.log('**** TEST panel p za export sastavnicu');
  // console.log(p);
  let j = {
    ...default_element(p)
  };
  j.Naziv = p.naziv;
  // j.Tip = p.tippanela;
  j.Tip = p.tip;
  //
  j.Materijal = p.termaterijal; // TDDO ???
  j.CNC_program1 = p.cncprogram1; // TDDO ???
  //
  if (p.virtelclass === 'terkk$panel$lim_spoljasnji' || p.virtelclass === 'terkk$panel$lim_spoljasnji_opsec' || p.virtelclass === 'terkk$panel$lim_spoljasnji_opsav') {
    let jj = {
      ...j,
      ..._special_Par_za_panel_i_lim_helper(p)
    };
    // Generalno su to isti parametri kao i za sam panel samo se izbacuju za unutrsanji lim - Par12,Par13,Par14 i Par15
    delete jj.Par12;
    delete jj.Par13;
    // delete jj.Par14; // --
    delete jj.Par15;
    delete jj.Par16; // ++
    jj.Par14 = p.panel_lim_spoljasnji_tip; // TDDO ???
    // jj.Par16 = p.panel_lim_unutrasnji_tip; // TDDO ???
    jj._X_tippanela = p.tippanela; //
    //
    jj._ident_modula = null;
    if (typeof _ident_modula === 'string') {
      jj._ident_modula = _ident_modula;
    }
    jj._ident_nadredjenog = null;
    if (typeof _ident_nadredjenog === 'string') {
      jj._ident_nadredjenog = _ident_nadredjenog;
    }
    jj._debug = 'panel$derivat1 lim spolj.';
    return jj;
  } else if (p.virtelclass === 'terkk$panel$lim_unutrasnji' || p.virtelclass === 'terkk$panel$lim_unutrasnji_opsec' || p.virtelclass === 'terkk$panel$lim_unutrasnji_opsav') {
    let jj = {
      ...j,
      ..._special_Par_za_panel_i_lim_helper(p)
    };
    // Generalno su to isti parametri kao i za sam panel samo se izbacuju za spoljasnji lima - Par12,Par13,Par15 i Par16
    delete jj.Par12;
    delete jj.Par13;
    delete jj.Par14; // ++
    delete jj.Par15;
    // delete jj.Par16; // --
    // jj.Par14 = p.panel_lim_spoljasnji_tip; // TDDO ???
    jj.Par16 = p.panel_lim_unutrasnji_tip; // TDDO ???
    jj._X_tippanela = p.tippanela; //
    //
    jj._ident_modula = null;
    if (typeof _ident_modula === 'string') {
      jj._ident_modula = _ident_modula;
    }
    jj._ident_nadredjenog = null;
    if (typeof _ident_nadredjenog === 'string') {
      jj._ident_nadredjenog = _ident_nadredjenog;
    }
    jj._debug = 'panel$derivat1 lim unutr.';
    return jj;
  } else if (p.virtelclass === 'terkk$panel$ojacanje' || p.virtelclass === 'terkk$panel$ojacanje_opsec' || p.virtelclass === 'terkk$panel$ojacanje_opsav') {
    let jj = {
      ...j,
    };
    // ???
    jj.Par1 = p.duzina; // 2022-12-21 DL: Par1 za ojacanje treba da bude duzina ojacanja
    //
    jj._ident_modula = null;
    if (typeof _ident_modula === 'string') {
      jj._ident_modula = _ident_modula;
    }
    jj._ident_nadredjenog = null;
    if (typeof _ident_nadredjenog === 'string') {
      jj._ident_nadredjenog = _ident_nadredjenog;
    }
    jj._debug = 'panel$derivat1 ojac.';
    return jj;
  }
  //
  j._ident_modula = null;
  if (typeof _ident_modula === 'string') {
    j._ident_modula = _ident_modula;
  }
  j._ident_nadredjenog = null;
  if (typeof _ident_nadredjenog === 'string') {
    j._ident_nadredjenog = _ident_nadredjenog;
  }
  //
  j._debug = 'panel$derivat1';
  return _special_enrich_by_extra_siframodula(p, j);
};


element.demper = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  console.log('+++++++++ greska oko tip dempera - p:');
  console.log(p);
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  j.Naziv = p.naziv;
  j.Tip = p.tipdempera;
  j.Kolicina = p.kolicina;
  //
  j.Par1 = p.unutrasnjasirina;
  j.Par2 = p.unutrasnjavisina;
  // j.Par3 = p.brojkrilaca;
  // j.Par4 = p.vrstapogona;
  if (p.vrstapogona === 'rucni') {
    j.Par3 = tclocal.SASINT_YES; // Da li ima rucku
  } else {
    j.Par3 = tclocal.SASINT_NO;
  }
  // j.Par3 = p.osovina;
  j.Par4 = p.osovina;
  //
  return _special_enrich_by_extra_siframodula(p, j);
};


element.elasticnaveza = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  j.Naziv = p.naziv;
  j.Kolicina = p.kolicina;
  //
  // j.Par1 = p.prirubnica;
  // j.Par2 = p.platno;
  // j.Par3 = p.sirinaa;
  // j.Par4 = p.visinab;
  j.Par1 = p.sirinaa;
  j.Par2 = p.visinab;
  if (p.montiranjenademper === true) {
    j.Par3 = tclocal.SASINT_YES;
  } else {
    j.Par3 = tclocal.SASINT_NO;
  }
  j.Par4 = p.platno;
  j.Par5 = p.prirubnica;
  //
  return _special_enrich_by_extra_siframodula(p, j);
};


element.eliminatorkapi = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  let eliminatorKapiNaziv = 'ELIMINATOR KAPI ' + p.sirina + ' x ' + p.visina;
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  j.Naziv = eliminatorKapiNaziv;
  j.Tip = p.tipeliminatorakapi;
  j.Kolicina = p.kolicina;
  //
  j.Par1 = p.sirina;
  j.Par2 = p.visina;
  //
  return _special_enrich_by_extra_siframodula(p, j);
};


element.spoljnafiksnazaluzina = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  j.Naziv = p.naziv;
  j.Tip = p.tipspoljnefiksnezaluzine;
  j.Kolicina = p.kolicina;
  //
  j.Par1 = p.unutrasnjasirina;
  j.Par2 = p.unutrasnjavisina;
  //
  return _special_enrich_by_extra_siframodula(p, j);
};


element.kadica = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  j.Naziv = p.naziv;
  j.Tip = p.tip;
  j.Kolicina = p.kolicina;
  //
  j.Par1 = p.duzina;
  j.Par2 = p.sirina;
  j.Par3 = p.odvodkondenzata;
  //
  j.CNC_crtez = p.cnccrtez;
  if (p.rc === "RCPRBAM") {
    // ODLUKA DL 2022-12-06: Tamo gde je radni centar amada da bude isti cncprogram kao i cnccrtez.
    j.CNC_program1 = p.cnccrtez;
  }
  //
  if (p.virtelclass === "terkk$kadica.1.1") {
    //
    console.log('ovaj je "terkk$kadica.1.1" EX terkk$kadica_lim');
    // j.Par30 = p.siframodula; // TODO treba odluciti koji parametar to da bude
    j._ident_nadredjenog = p.siframodula; // TODO treba odluciti koji parametar to da bude
  }
  //
  j._ident_modula = null;
  if (typeof _ident_modula === 'string') {
    j._ident_modula = _ident_modula;
  }
  j._ident_nadredjenog = null;
  if (typeof _ident_nadredjenog === 'string') {
    j._ident_nadredjenog = _ident_nadredjenog;
  }
  // console.log('+++ KADICA LIM p j ', p , j);
  j._debug = 'kadica';
  // console.log('element kadica', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.postolje = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  j.Naziv = p.naziv;
  j.Tip = p.tip;
  j.Kolicina = p.kolicina;
  //
  j.Par1 = p.duzinapostolja;
  j.Par2 = p.sirinapostolja;
  j.Par3 = p.visinapostolja;
  j.Par4 = p.sirinaprofilapostolja; // ODLUKA DL 2022-12-29 da imamo i taj parametar u sastavnici ako nekad u buducnosti zatreba
  //
  //
  j.Par6 = p.pozicijaojacanja_poduzini_pack;
  j.Par7 = p.pozicijaojacanja_posirini_pack;
  j.Par8 = p.pozicijaodvodakondenzata_pack;
  //
  j._ident_modula = null;
  if (typeof _ident_modula === 'string') {
    j._ident_modula = _ident_modula;
  }
  j._ident_nadredjenog = null;
  if (typeof _ident_nadredjenog === 'string') {
    j._ident_nadredjenog = _ident_nadredjenog;
  }
  //
  j._debug = 'postolje';
  return _special_enrich_by_extra_siframodula(p, j);
};


element.postolje_profil = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  j.Naziv = p.naziv;
  j.Tip = p.tip;
  j.Kolicina = p.kolicina;
  //
  j.Par3 = p.visinapostolja;
  j.Par4 = p.sirinaprofilapostolja;
  j.Par5 = p.duzina; // duzina profila postolja
  //
  j.Par9 = p.pozicijaojacanja1;
  j.Par10 = p.pozicijaojacanja2;
  j.Par11 = p.pozicijaojacanja3;
  j.Par12 = p.pozicijaojacanja4;
  // ***** pa jps 6 mesta prazno
  //
  j.Par19 = p.pozicijaodvodakondenzata1;
  j.Par20 = p.pozicijaodvodakondenzata2;
  j.Par21 = p.pozicijaodvodakondenzata3;
  //
  j.CNC_crtez = p.cnccrtez;
  j.CNC_program1 = p.cncprogram1;
  //
  j._ident_modula = null;
  if (typeof _ident_modula === 'string') {
    j._ident_modula = _ident_modula;
  }
  j._ident_nadredjenog = null;
  if (typeof _ident_nadredjenog === 'string') {
    j._ident_nadredjenog = _ident_nadredjenog;
  }
  //
  j._debug = 'postoljeprofil';
  return _special_enrich_by_extra_siframodula(p, j);
};


element.ppv = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Ident = null;
  j.Naziv = p.naziv;
  // j.Tip = p.tip;
  j.Tip = p.ppv_tip;
  j.Kolicina = p.kolicina;
  //
  j.Par1 = p.ppv_b; // sirina ppv sekcije
  j.Par2 = p.ppv_b1; // sirina od pocetka leve strane do rupe
  j.Par3 = p.ppv_b2; // dimenzija rupe
  j.Par4 = p.ppv_b3; // sirina od rupe do kraja desne strane
  j.Par5 = p.ppv_b4; // sirina ppv sekcije
  j.Par6 = p.ppv_h; // visina ppv sekcije
  j.Par7 = p.ppv_h1; // visina od dna sekcije do rupe
  j.Par8 = p.ppv_h2; // dimenzija rupe
  j.Par9 = p.ppv_h3; // visina iznad rupe do vrha sekcije
  j.Par10 = p.ppv_h4; // visina ppv sekcije
  j.Par11 = p.ppv_o1; // Rastojanje izmedju otvora el veze
  j.Par12 = p.ppv_o2; // Rastojanje otvora srednjih 12 otvora
  j.Par13 = p.ppv_kolikootvorazaelv;
  j.Par15 = p.ppv_isojacanjapovisini;
  j.Par16 = p.ppv_isojacanjaposirini;

  //
  j._debug = 'ppv';
  return _special_enrich_by_extra_siframodula(p, j);
};
element.ppv_sekcija = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Naziv = p.naziv;
  j.Tip = p.tip;
  j.Kolicina = p.kolicina;
  //
  if (!(p.ppv_4dstrana === "SREDINA" || p.ppv_4dstrana === "NONE")) {
    // za sve osim ojacanja i poklopcica
    j.Par11 = p.ppv_o1; // Rastojanje izmedju otvora el veze
    j.Par12 = p.ppv_o2; // Rastojanje otvora srednjih 12 otvora
    j.Par13 = p.ppv_kolikootvorazaelv;
    j.Par17 = p.ppv_medjuspoj_top;
    j.Par18 = p.ppv_medjuspoj_bottom;
    j.Par19 = p.ppv_medjuspoj_left;
    j.Par20 = p.ppv_medjuspoj_right;
  }
  if (p.ppv_4dstrana === "1D") {
    j.Par2 = p.ppv_b1; // sirina od pocetka leve strane do rupe
    j.Par3 = p.ppv_b2; // dimenzija rupe
    j.Par5 = p.ppv_b4; // sirina ppv sekcije
    j.Par7 = p.ppv_h1; // visina od dna sekcije do rupe
    j.Par8 = p.ppv_h2; // dimenzija rupe
    j.Par10 = p.ppv_h4; // visina ppv sekcije
    j.Par15 = p.ppv_isojacanjapovisini;
    j.Par16 = p.ppv_isojacanjaposirini;
    if (p.ppv_bezotvora === true) { // NJ 2025-03-20: p.ppv_bezotvora Par21 "DA" ili null.
      j.Par21 = "DA";
    } else {
      // j.Par21 = null;
    }
  }
  if (p.ppv_4dstrana === "4D_LEVO") {
    j.Par2 = p.ppv_b1; // sirina od pocetka leve strane do rupe
    j.Par10 = p.ppv_h4; // visina ppv sekcije
  }
  if (p.ppv_4dstrana === "6D_LEVO" || p.ppv_4dstrana === "6D_LEVO_2") {
    j.Par2 = p.ppv_b1_6d; // sirina +++
    j.Par10 = p.ppv_h4; // visina ppv sekcije
  }
  if (p.ppv_4dstrana === "4D_DOLE" || p.ppv_4dstrana === "6D_DOLE") {
    j.Par3 = p.ppv_b2; // dimenzija rupe
    j.Par7 = p.ppv_h1; // visina od dna sekcije do rupe
  }
  if (p.ppv_4dstrana === "4D_DESNO") {
    j.Par4 = p.ppv_b3; // sirina od rupe do kraja desne strane
    j.Par10 = p.ppv_h4; // visina ppv sekcije
  }
  if (p.ppv_4dstrana === "6D_DESNO" || p.ppv_4dstrana === "6D_DESNO_2") {
    j.Par2 = p.ppv_b3_6d; // sirina +++
    j.Par10 = p.ppv_h4; // visina ppv sekcije
  }
  if (p.ppv_4dstrana === "4D_GORE" || p.ppv_4dstrana === "6D_GORE") {
    j.Par3 = p.ppv_b2; // dimenzija rupe
    j.Par9 = p.ppv_h3; // visina iznad rupe do vrha sekcije
  }
  //
  if (p.ppv_4dstrana === "4D_LEVO" || p.ppv_4dstrana === "4D_DESNO") {
    j.Par3 = p.ppv_b2; // dimenzija rupe
    j.Par7 = p.ppv_h1; // visina od dna sekcije do rupe
    j.Par8 = p.ppv_h2; // dimenzija rupe
    j.Par9 = p.ppv_h3; // visina iznad rupe do vrha sekcije
    j.Par15 = p.ppv_isojacanjapovisini;
    j.Par16 = p.ppv_isojacanjaposirini;
  }
  if (p.ppv_4dstrana === "6D_LEVO" || p.ppv_4dstrana === "6D_DESNO") {
    j.Par15 = p.ppv_isojacanjapovisini;
    j.Par16 = p.ppv_isojacanjaposirini;
  }
  if (p.ppv_4dstrana === "6D_LEVO_2" || p.ppv_4dstrana === "6D_DESNO_2") {
    j.Par3 = p.ppv_b2; // dimenzija rupe
    j.Par7 = p.ppv_h1; // visina od dna sekcije do rupe
    j.Par8 = p.ppv_h2; // dimenzija rupe
    j.Par9 = p.ppv_h3; // visina iznad rupe do vrha sekcije
    j.Par15 = p.ppv_isojacanjapovisini;
    j.Par16 = p.ppv_isojacanjaposirini;
  }
  if (p.ppv_4dstrana === "4D_DOLE" || p.ppv_4dstrana === "4D_GORE" || p.ppv_4dstrana === "6D_DOLE" || p.ppv_4dstrana === "6D_GORE") {
    j.Par16 = p.ppv_isojacanjaposirini;
  }
  //
  if (p.tip === "PPV_OJACANJE_VERTIKALNO") {
    j.Par6 = p.ppv_h; // visina ppv sekcije
    j.Par10 = p.ppv_h4; // visina ppv sekcije
  }
  if (p.tip === "PPV_OJACANJE_HORIZONTALNO") {
    j.Par1 = p.ppv_b; // sirina ppv sekcije
    j.Par5 = p.ppv_b4; // sirina ppv sekcije
  }
  //
  if (p.tip === "PPV_POKLOPCIC") {
    // TODO
  }
  //
  j.CNC_program1 = p.cncprogram1;
  //
  j._ident_modula = null;
  if (typeof _ident_modula === 'string') {
    j._ident_modula = _ident_modula;
  }
  j._ident_nadredjenog = null;
  if (typeof _ident_nadredjenog === 'string') {
    j._ident_nadredjenog = _ident_nadredjenog;
  }
  //
  j._debug = 'ppv sekcija';
  return _special_enrich_by_extra_siframodula(p, j);
};


element.univerzalniPoluproizvod = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  let _p_Naziv = null;
  if (p.naziv) {
    _p_Naziv = p.naziv;
  }
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  j.Custom_ident = 'NE JOS';
  // j.Naziv = p.naziv;
  j.Naziv = _p_Naziv;
  j.Tip = p.tip;
  // j.Kolicina = p.kolicina;
  //
  j.Par1 = p.duzina;
  //
  j._debug = 'uni PP';
  // console.log('element univerzalniPoluproizvod', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.krov_lim = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice materijalcustom
  // let j_RUCNO_PREVEDENE = {};
  let j = { // _RUCNO_PREVEDENE
    ...default_element(p)
  };
  j.Naziv = p.naziv;
  // j.Grupa = p.tergrupacustom; // ???
  // j.Ident = p.identcustom;
  j.Ident = null; // njegov ident je zapravo za materijal
  // j.Tip = p.tipkrovnogsegmenta;
  j.Tip = p.tip;
  //
  j.CNC_program1 = p.cncprogram1;
  j.CNC_crtez = p.cnccrtez;
  if (p.rc === "RCPRBAM") {
    // ODLUKA DL 2022-12-06: Tamo gde je radni centar amada da bude isti cncprogram kao i cnccrtez.
    j.CNC_program1 = p.cnccrtez;
  }
  //
  j._ident_modula = null;
  if (typeof _ident_modula === 'string') {
    j._ident_modula = _ident_modula;
    // j._ident_nadredjenog = _ident_modula; // BUDZENJE
  }
  j._ident_nadredjenog = null;
  if (typeof _ident_nadredjenog === 'string') {
    j._ident_nadredjenog = _ident_nadredjenog; // PRAVILNO
  }
  //
  // j.Kolicina = terUtilsNumberRoundUp(p.kolicina, 2); // DL 2023-06-13: trebalo bi general;no svuda kod limova da bude na dve decimale.
  //
  j.Par1 = p.duzina;
  j.Par2 = p.sirina;
  j.Par3 = p.krovniotvor;
  j.Par4 = p.a;
  j.Par5 = p.b;
  j.Par6 = p.x;
  j.Par7 = p.y;
  //
  //
  // const cnc_variables_prevedene = {};
  // const _jezik = j["Par_jezik"];
  // const recnik_kljuceva = ter_recnik_kljuceva_smart_get(_jezik);
  // console.log('element.krov_lim recnik_kljuceva', recnik_kljuceva);
  /*
  {
      "thisis": "RECNIK_KLJUCEVA",
      "subrecnik": {
          "virtel_key": {
              "duzina": {
                  "virtel_key": "duzina",
                  "sasint_key": "Par1",
                  "sasexcel_key": "p",
                  "cncvars_key": "$duzina$",
                  "_sublang_arr": [
                      "terkk$krov/child_abcde",
                      "terkk$krov/snala"
                  ]
              },
              "sirina": {
                  "virtel_key": "sirina",
                  "sasint_key": "Par2",
                  "sasexcel_key": "q",
                  "cncvars_key": "$sirina$",
                  "_sublang_arr": [
                      "terkk$krov/child_abcde"
                  ]
              },
              "krovniotvor": {
                  "virtel_key": "krovniotvor",
                  "sasint_key": "Par3",
                  "sasexcel_key": "r",
                  "cncvars_key": "$krovniotvor$",
                  "_sublang_arr": [
                      "terkk$krov/child_abcde"
                  ]
              },
              "a": {
                  "virtel_key": "a",
                  "sasint_key": "Par4",
                  "sasexcel_key": "s",
                  "cncvars_key": "$a$",
                  "_sublang_arr": [
                      "terkk$krov/child_abcde"
                  ]
              },
              "b": {
                  "virtel_key": "b",
                  "sasint_key": "Par5",
                  "sasexcel_key": "t",
                  "cncvars_key": "$b$",
                  "_sublang_arr": [
                      "terkk$krov/child_abcde"
                  ]
              },
              "x": {
                  "virtel_key": "x",
                  "sasint_key": "Par6",
                  "sasexcel_key": "u",
                  "cncvars_key": "$x$",
                  "_sublang_arr": [
                      "terkk$krov/child_abcde"
                  ]
              },
              "y": {
                  "virtel_key": "y",
                  "sasint_key": "Par7",
                  "sasexcel_key": "v",
                  "cncvars_key": "$y$",
                  "_sublang_arr": [
                      "terkk$krov/child_abcde"
                  ]
              }
          }
      }
  }
  */
  // TODO
  /*
  const by = "virtel_key";
  const subrecnik_id = "virtel_key";
  if (recnik_kljuceva && recnik_kljuceva.subrecnik && recnik_kljuceva.subrecnik[subrecnik_id]) {
    const _prevodi_obj = recnik_kljuceva.subrecnik[subrecnik_id];
  }
  //
  Object.keys(j).forEach((sasint_key) => {
    const multiprevodJednogKljuca = multitranslator_v2_get_multiprevodJednogKljuca(recnik_kljuceva, "virtel_key", _jezik, "sasint_key", sasint_key);
    if (multiprevodJednogKljuca && typeof multiprevodJednogKljuca.cncvars_key === 'string') {
      const val = j[sasint_key];
      const cncvars_key = multiprevodJednogKljuca["cncvars_key"];
      cnc_variables_prevedene[cncvars_key] = _cnc_vars_value_fix(val);
    }
  });
  */
  //
  //
  j._debug = 'krov_lim';
  console.log('element krov_lim j p', j, p);
  return _special_enrich_by_extra_siframodula(p, j);
};


element._pp_grupa_LIM = (p, _ident_nadredjenog, _ident_modula) => {
  // NOVO
  let j = element.univerzalniPoluproizvod(p);
  j._ident_modula = null;
  if (typeof _ident_modula === 'string') {
    j._ident_modula = _ident_modula;
  }
  j._ident_nadredjenog = null;
  if (typeof _ident_nadredjenog === 'string') {
    j._ident_nadredjenog = _ident_nadredjenog;
  }
  //
  j._debug = 'PP gr. LIM';
  // console.log('element _pp_grupa_LIM', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.rogalj = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'M';
  j.Grupa = p.tergrupa; // ???
  j.Ident = p.calculated_ident;
  j.Naziv = p.naziv;
  j.Tip = p.tip;
  j.Kolicina = p.kolicina;
  //
  // j.JM = tclocal.JM_KOM;
  // j.JM = p.jm;
  //
  j.Par1 = p.duzina;
  //
  j._debug = 'rogalj';
  // console.log('element rogalj', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element._pp_grupa_PROFIL = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  j.Ident = null;
  // j.Custom_ident = 'NE JOS';
  j.Naziv = p.naziv;
  j.Tip = p.tip;
  j.Kolicina = p.kolicina;
  //
  j.Par1 = p.duzina;
  j.Par2 = p.leviger;
  j.Par3 = p.desniger;
  //
  if (p.modulprofil_kolikozaobradu && p.modulprofil_kolikozaobradu > 0) {
    j._modulprofil_kolikozaobradu = p.modulprofil_kolikozaobradu;
  }
  //
  if (js_utils.is_string_not_empty(p._ident_modula)) {
    j._ident_modula = p._ident_modula; // NJ 2025-03-02
  }
  //
  if (js_utils.is_string_not_empty(p.multitranslator_lang)) {
    j.Par_jezik = "terkk$grupa_profil/grupa_profil"; // BUDZENJE TODO uraditi na nivou samih virtela...
  }
  //
  j._debug = 'PP gr. PROFIL';
  // console.log('element _pp_grupa_PROFIL', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.univerzalniMaterijal = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'M';
  j.Grupa = null; // ???
  j.Ident = p.calculated_ident;
  j.Calculated_ident = p.calculated_ident;
  j.Naziv = p.naziv;
  // j.Tip = p.tip;
  j.Kolicina = p.kolicina; // TODO ovo je reseno u derivatima profila ali mozda postoje profili dempera i sl. kod kojih ovo nije reseno...
  //
  j._debug = 'uni M';
  // console.log('element univerzalniMaterijal', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.univerzalniMaterijal_od_tergrupa_lim = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'M';
  j.Grupa = null; // ???
  j.Ident = p.calculated_ident;
  // j.Ident = p.custom_ident; // TODO
  j.Naziv = p.naziv;
  // j.Tip = p.tip;
  j.Kolicina = terUtilsNumberRoundUp(p.kolicina, 2); // DL 2023-06-13: trebalo bi general;no svuda kod limova da bude na dve decimale.
  //
  j._debug = 'uni M gr. LIM';
  // console.log('element univerzalniMaterijal_od_tergrupa_lim', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.materijalcustom = (p) => {
  // objekat za element sastavnice materijalcustom
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = p.terkategorija;
  j.Grupa = p.tergrupacustom; // ???
  j.Ident = p.identcustom;
  j.Naziv = p.naziv;
  j.JM = p.jm;
  j.Kolicina = p.kolicina;
  j.Par28 = p.Par28;
  j.Par29 = p.Par29;
  return _special_enrich_by_extra_siframodula(p, j);
};
/*
element.profilcustom = (p) => {
  // umesto ovog koristi se element._pp_grupa_PROFIL
  // objekat za element sastavnice profilcustom
  let j = {
    ...default_element(p)
  };
  // j.Grupa = p.tergrupacustom; // ???
  // j.Ident = p.identcustom;
  j.Ident = null; // njegov ident je zapravo za materijal
  return _special_enrich_by_extra_siframodula(p, j);
};
*/
element.limcustom = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice materijalcustom
  let j = {
    ...default_element(p)
  };
  j.Naziv = p.naziv;
  // j.Grupa = p.tergrupacustom; // ???
  // j.Ident = p.identcustom;
  j.Ident = null; // njegov ident je zapravo za materijal
  //
  j.CNC_crtez = p.cnccrtez;
  if (p.rc === "RCPRBAM") {
    // ODLUKA DL 2022-12-06: Tamo gde je radni centar amada da bude isti cncprogram kao i cnccrtez.
    // j.CNC_program1 = p.cnccrtez;
  }
  if (j._CNC_tip === "S4" || j._CNC_tip === "AMADA") {
    // NOVO
    // DL 2024-04-27: Do sada je kod LIM CUSTOM polje cnccrtez bilo korisceno za CNC program a od sada treba da imamo oba polja i za S4 i za AMADA.
    j.CNC_program1 = p.cncprogram1;
  }
  // j.Kolicina = terUtilsNumberRoundUp(p.kolicina, 2); // DL 2023-06-13: trebalo bi general;no svuda kod limova da bude na dve decimale.
  //
  j.Par1 = p.sirina;
  // j.Par2 = p.visina;
  j.Par2 = p.duzina;
  //
  j._ident_modula = null;
  if (typeof _ident_modula === 'string') {
    j._ident_modula = _ident_modula;
    // j._ident_nadredjenog = _ident_modula; // BUDZENJE
  }
  // TODO
  if (js_utils.is_string_not_empty(p._ident_modula)) {
    j._ident_modula = p._ident_modula; // NJ 2025-03-02
  }
  //
  j._ident_nadredjenog = null;
  if (typeof _ident_nadredjenog === 'string') {
    j._ident_nadredjenog = _ident_nadredjenog; // PRAVILNO
  }
  //
  j._debug = 'limcustom';
  // console.log('element limcustom', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


element.grupa_ispuna = (p) => {
  // objekat za element sastavnice _____
  let j = element.univerzalniPoluproizvod(p);
  // DL 2023-11-02: Kamena vuna sirina i visina da se zaokruziuju normalno preko 0.5 ili manje od 0.5 na nula decimala.
  // vec je zaokruzeno u derivat funkcijama
  j.Par1 = p.sirina;
  j.Par2 = p.visina;
  //
  if (js_utils.is_string_not_empty(p.multitranslator_lang)) {
    j.Par_jezik = "terkk$grupa_ispuna/grupa_ispuna"; // BUDZENJE TODO uraditi na nivou samih virtela...
  }
  //
  j._debug = 'gr. ISPUNA';
  return _special_enrich_by_extra_siframodula(p, j);
};


//
element.special_by_lang = (p, _ident_nadredjenog, _ident_modula) => {
  // objekat za element sastavnice _____
  let j = element.univerzalniPoluproizvod(p);
  delete j.Par1;
  //
  //
  const _jezik = j["Par_jezik"];
  if (js_utils.is_string_not_empty(_jezik)) {
    const recnik_kljuceva = ter_recnik_kljuceva_smart_get(_jezik);
    // console.log('+++ recnik_kljuceva', recnik_kljuceva);
    if (recnik_kljuceva && recnik_kljuceva.subrecnik && recnik_kljuceva.subrecnik.virtel_key) {
      const _recnik_obj = recnik_kljuceva.subrecnik.virtel_key;
      Object.keys(_recnik_obj).forEach((key) => {
        const _multiprevod = _recnik_obj[key];
        if (_multiprevod._sublang_arr.includes(_jezik)) {
          // populate sastavnica field
          j[_multiprevod.sasint_key] = p[_multiprevod.virtel_key];
        }
      });
    }
    //
    // console.log('p', p);
    if (js_utils.is_string_not_empty(p.tip)) {
      // ODLUKA DL 2022-12-06: Tamo gde je radni centar amada da bude isti cncprogram kao i cnccrtez.
      j.Tip = p.tip;
    }
    //
    j.CNC_crtez = p.cnccrtez;
    if (p.rc === "RCPRBAM") {
      // ODLUKA DL 2022-12-06: Tamo gde je radni centar amada da bude isti cncprogram kao i cnccrtez.
      j.CNC_program1 = p.cnccrtez;
    } else {
      if (p.cncprogram1 && j._CNC_tip === "S4") {
        j.CNC_program1 = p.cncprogram1;
      }
    }
    //
    j._ident_modula = null;
    if (typeof _ident_modula === 'string') {
      j._ident_modula = _ident_modula;
      // j._ident_nadredjenog = _ident_modula; // BUDZENJE
    }
    j._ident_nadredjenog = null;
    if (typeof _ident_nadredjenog === 'string') {
      j._ident_nadredjenog = _ident_nadredjenog; // PRAVILNO
    }
    //
  }
  //
  //
  j._debug = 'special_by_lang';
  return _special_enrich_by_extra_siframodula(p, j);
};




/*
element.kamenavuna_m = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  j.Kat = 'M';
  j.Grupa = null; // ???
  j.Ident = p.calculated_ident;
  j.Naziv = p.naziv;
  // j.Tip = p.tip;
  j.Kolicina = p.kolicina; // TODO ovo je reseno u derivatima profila ali mozda postoje profili dempera i sl. kod kojih ovo nije reseno...
  //
  // j.JM = p.jm; // m2
  //
  return _special_enrich_by_extra_siframodula(p, j);
};
*/


// experimental
element.zzkitc_kitc = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  // j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  // j.Ident = p.calculated_ident;
  // j.Calculated_ident = p.calculated_ident;
  j.Naziv = p.naziv;
  const _radnih_sati = j.Vreme_kumulativno / 60;
  j.Naziv = p.naziv + ' (cena rada: ' + (_radnih_sati) + 'h x 15EUR =' + (_radnih_sati * 15) + ' EUR)';
  j.Tip = p.tip;
  j.Kolicina = p.kolicina; // TODO ovo je reseno u derivatima profila ali mozda postoje profili dempera i sl. kod kojih ovo nije reseno...
  //
  j._debug = 'zz kitc kitc';
  // console.log('element univerzalniMaterijal', j);
  return _special_enrich_by_extra_siframodula(p, j);
};
element.zzkitc_wbp_pp = (p) => {
  // objekat za element sastavnice _____
  let j = {
    ...default_element(p)
  };
  j.Nivo = p.bomlevel;
  // j.Kat = 'PP';
  j.Grupa = p.tergrupa; // ???
  // j.Ident = p.calculated_ident;
  // j.Calculated_ident = p.calculated_ident;
  j.Naziv = p.naziv;
  // j.Tip = p.tip;
  j.Tip = p.pbnode_family;
  j.Kolicina = p.kolicina; // TODO ovo je reseno u derivatima profila ali mozda postoje profili dempera i sl. kod kojih ovo nije reseno...
  //
  j.Par1 = p.dim_cut2d_uzduz;
  j.Par2 = p.dim_cut2d_popreko;
  j.Par3 = p.debljina;
  j.Par4 = p.kuh_kojimaterijal;
  j.Par5 = p.orijentacija; // USMERENA
  j.Par6 = p.duzina;
  j.Par7 = p.sirina;
  j.Par8 = p.dubina;
  //
  j._debug = 'zz kitc wbp PP';
  // console.log('element univerzalniMaterijal', j);
  return _special_enrich_by_extra_siframodula(p, j);
};


export default element;